import {
    getDriverService,
    loginService,
    sendForgetPasswordEmailService,
    updateDriverService,
    loginImageService,
    ssoAuthService,
    portalLoginService,
    submitInitialEmailService,
} from '../../services/authServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

export async function loginUser(dispatch, loginPayload, ssoAuth = false) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        let response;
        if (ssoAuth) {
            response = await ssoAuthService(loginPayload);
        } else {
            response = await loginService(loginPayload);
        }

        if (response.data) {
            dispatch({ type: 'LOGIN_SUCCESS', payload: response.data.user });
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('token', JSON.stringify(response.data.token));
            localStorage.setItem('driverportal_version', response.headers.driverportal_version);
            localStorage.setItem('driverportal_logout_version', response.headers.driverportal_logout_version);
            // Backup auth to native layer (AsyncStorage) so it survives WebView process termination
            window.postToRN?.({ type: 'authToken', token: response.data.token, user: response.data.user });
            return response.data;
        }

        dispatch({
            type: 'LOGIN_ERROR',
            error: response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ',
        });
        return response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ';
    } catch (error) {
        dispatch({
            type: 'LOGIN_ERROR',
            error: error.response.data.message ? error.response.data.message : 'Invalid Email or password!',
        });
    }
}

export async function portalLogin(dispatch, loginPayload) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        let response = await portalLoginService(loginPayload);

        if (response.data) {
            return response.data;
        }

        dispatch({
            type: 'LOGIN_ERROR',
            error: response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ',
        });
        return response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ';
    } catch (error) {
        dispatch({
            type: 'LOGIN_ERROR',
            error: error.response.data.message ? error.response.data.message : 'Invalid Email or password!',
        });
    }
}

export async function submitInitialEmail(dispatch, emailAddress) {
    try {
        let response = await submitInitialEmailService(emailAddress);
        if (response.data) {
            return response.data;
        }
        dispatch({
            type: 'LOGIN_ERROR',
            error: response.data.errorMessage ? response.data.errorMessage : 'Error occurred while fetching portals',
        });
        return null;
    } catch (error) {
        dispatch({
            type: 'LOGIN_ERROR',
            error: error.response?.data?.message
                ? error.response.data.message
                : 'Error occurred while fetching portals',
        });
        throw error;
    }
}

export async function getDriver(dispatch, data, scope) {
    try {
        let response = await getDriverService(data, scope);

        if (response.data) {
            dispatch({ type: 'GET_DRIVER_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'GET_DRIVER_ERROR', error: response.data.errors[0] });
    } catch (error) {
        dispatch({ type: 'GET_DRIVER_ERROR', error: error });
    }
}

export async function updateDriver(dispatch, data, driverId) {
    try {
        let response = await updateDriverService(data, driverId);

        if (response.data) {
            dispatch({ type: 'UPDATE_DRIVER_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'UPDATE_DRIVER_ERROR', error: response.data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'UPDATE_DRIVER_ERROR', error: error });
    }
}

export async function sendForgetPasswordEmail(dispatch, payload) {
    try {
        let response = await sendForgetPasswordEmailService(payload);
        if (response.data) {
            if (response.data[0].statusCode === 200 || response.data[0].statusCode === 202) {
                dispatch({ type: 'SEND_EMAIL_SUCCESS', payload: response.data });
                return;
            }
        }
        dispatch({ type: 'SEND_EMAIL_ERROR', error: response.data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'SEND_EMAIL_ERROR', error: error });
    }
}

export async function getLoginImage(dispatch) {
    try {
        let response = await loginImageService();
        if (response.data) {
            dispatch({ type: 'GET_LOGIN_IMAGE_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'GET_LOGIN_IMAGE_ERROR', error: response.data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'GET_LOGIN_IMAGE_ERROR', error: error });
    }
}
